export default __webpack_public_path__ + "static/media/city-hall-forum-negative.d3954187.svg";